import { OrganizationScope, useCurrentCompany, useCurrentUser, useUserFromAuth } from '@neo.tax/shared';

/**
 * Whether the current user may move the period lock on the company in view.
 *
 * A user holds at most one organization scope, so organizationScope on its own only says the user
 * administers some organization. setAscPeriodLock grants ORGANIZATION_ADMIN on the fiscal year only
 * when that organization owns the company, so the organization has to be compared as well —
 * otherwise an admin of another organization is offered a write the server rejects.
 */
export const useCanSetAscPeriodLock = (): boolean => {
  const { isSuperUserMode } = useUserFromAuth();
  const { user } = useCurrentUser();
  const { company } = useCurrentCompany();

  const isOrganizationAdminOfViewedCompany =
    user?.organizationScope === OrganizationScope.OrganizationAdmin &&
    !!company?.organizationId &&
    user.organization?.id === company.organizationId;

  return isSuperUserMode || isOrganizationAdminOfViewedCompany;
};
